export const splitViewTokens = {
  // Panel layout
  'split-view-left-width':          '280px',
  'split-view-bg':                  'var(--dp-color-surface)',
  'split-view-left-bg':             'var(--dp-color-background)',
  'split-view-left-border':         'var(--dp-color-border)',
  'split-view-right-bg':            'var(--dp-color-surface)',

  // List items
  'split-view-item-hover-bg':       'var(--dp-color-surface)',
  'split-view-item-active-bg':      'var(--dp-color-primary-light)',
  'split-view-item-active-text':    'var(--dp-color-primary)',

  // Rule group card
  'split-view-group-bg':            'var(--dp-color-background)',
  'split-view-group-border':        'var(--dp-color-border)',
  'split-view-group-header-bg':     'var(--dp-color-surface)',
  'split-view-group-header-border': 'var(--dp-color-border)',
  'split-view-group-radius':        'var(--dp-border-radius-lg)',

  // Rule pill
  'split-view-rule-bg':             'var(--dp-color-surface)',
  'split-view-rule-border':         'var(--dp-color-border)',
  'split-view-rule-radius':         'var(--dp-border-radius-md)',
  'split-view-rule-field-color':    'var(--dp-color-primary)',
  'split-view-rule-op-color':       'var(--dp-color-accent)',
  'split-view-rule-op-bg':          'var(--dp-color-error-bg)',
  'split-view-value-tag-bg':        'var(--dp-color-primary-light)',
  'split-view-value-tag-color':     'var(--dp-color-primary)',

  // OR separator
  'split-view-sep-color':           'var(--dp-color-accent)',
  'split-view-sep-bg':              'var(--dp-color-error-bg)',

  // Add rule form
  'split-view-add-rule-bg':         'var(--dp-color-warning-bg)',
  'split-view-add-rule-border':     'var(--dp-color-warning)',
} as const;

export type SplitViewTokens = typeof splitViewTokens;
